import React from 'react';

import ReportDataProblemModal from './ReportDataProblemModal';
import moment from 'moment';

import useLocalStorage from '@cobliteam/hooks/src/useLocalStorage';

const REPORT_DATA_PROBLEM_MODAL_LAST_RESEARCH_TIME =
  'reportDataProblemModalLastResearchTime';
const EXPIRE_TIME_IN_MILLIS = 15 * 24 * 60 * 60 * 1000; //15 days

interface ReportDataProblemModalTriggerProps {
  showIfAvailable: boolean;
}

const ReportDataProblemModalTrigger = ({
  showIfAvailable,
}: ReportDataProblemModalTriggerProps) => {
  const [lastReachTime, setLastReachTime] = useLocalStorage<number | undefined>(
    REPORT_DATA_PROBLEM_MODAL_LAST_RESEARCH_TIME
  );
  const currentTimestamp = moment().valueOf();
  const reachTimeHasExpired =
    lastReachTime === undefined ||
    currentTimestamp - lastReachTime > EXPIRE_TIME_IN_MILLIS;

  const handleCloseModal = () => {
    setLastReachTime(currentTimestamp);
  };

  if (showIfAvailable && reachTimeHasExpired) {
    return <ReportDataProblemModal onClose={handleCloseModal} />;
  }

  return null;
};

export default ReportDataProblemModalTrigger;
